import { ISelfServeBrandOrder } from "@faire/web-api--source/indigofair/helpcenter/ISelfServeBrandOrder";

export const orderIsFreeShippingEligible = (
  brandOrder: ISelfServeBrandOrder
) => {
  const selectedBrandOrder = brandOrder.brand_order;

  return (
    selectedBrandOrder?.free_shipping ||
    !!selectedBrandOrder?.free_shipping_reason
  );
};
